import * as React from 'react';

import classNames from 'classnames';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from '../icon/svg/loading-icon';

type Props = {
    size?: number;
    padding?: number;
    fill?: string;
    fullHeight?: boolean;
};

export function LoadingPage(props: Props) {
    const {fill = colors.orangeLt, fullHeight = true} = props;

    const className = classNames('full-width flex align-center justify-center border-box', {
        'full-height': fullHeight,
    });

    return (
        <div
            style={{padding: typeof props.padding === 'number' ? `${props.padding}px` : '24px'}}
            className={className}
        >
            <LoadingIcon size={props.size} fill={fill} />
        </div>
    );
}
